import I18n from 'components/I18n'
import BankIcon from 'components/Icons/Bank'
import CheckCircleIcon from 'components/Icons/CheckCircle'
import palette from 'components/palette'
import messages from 'lang'
import React from 'react'

import { Wrapper } from '../../../styles'
import { Description, ImageWrapper, Title } from '../../styles'

type Props = {
  name: string
}

const Linked = ({ name }: Props) => (
  <Wrapper>
    <ImageWrapper>
      <BankIcon fill={palette.primary} size='72' />
      <CheckCircleIcon fill={palette.successMuted} size='32' />
    </ImageWrapper>
    <Title>
      <I18n data={messages.link_bank_success_title} />
    </Title>
    <Description>
      <I18n data={messages.link_bank_success_subtitle} name={name} />
    </Description>
  </Wrapper>
)

export default Linked
